import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import { token } from '@atlaskit/tokens';

import { wacToken } from '@/libraries/design/foundations';

const logoAlignedSkipLink = css({
	':focus': { insetInlineStart: 'var(--global-nav-skip-inset, 0px)' },
});

export const SkipToContent = ({ alignToLogo = false }: { alignToLogo?: boolean }) => {
	const intl = useIntl();

	const skipToContentStyles = css({
		position: 'absolute',
		zIndex: 999,
		marginBlockStart: token('space.025'),
		paddingInline: token('space.200'),
		paddingBlock: '10px',
		backgroundColor: wacToken('color.neutral.light0'),
		color: wacToken('color.primary.black'),
		insetBlockStart: '100%',
		insetInlineStart: '-9999px', // Moves the link off-screen to the left, making it invisible, but still focus-able

		':focus': {
			insetInlineStart: 'auto',
		},
	});

	return (
		<a
			href="#content"
			className="skip-to-content"
			css={[skipToContentStyles, alignToLogo && logoAlignedSkipLink]}
			data-testid="skip-to-content"
			// This link is rendered first in the nav DOM, so natural tab order already makes it
			// the first thing tabbed. A positive tabIndex would jump it ahead of the whole page
			// (WCAG 2.4.3) without changing anything here.
			tabIndex={0}
		>
			{intl.formatMessage({
				id: 'nav.skipToContent',
				defaultMessage: 'Skip to content',
			})}
		</a>
	);
};
